import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../images/logo_onlineico_v.png';

const linkStyle = {
    color: '#64748b', fontSize: '0.82rem', cursor: 'pointer',
    textDecoration: 'none', transition: 'color 0.2s', display: 'block', marginBottom: '10px'
};

function FooterLink({ label, onClick }) {
    const [hovered, setHovered] = useState(false);
    return (
        <span
            onClick={onClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{ ...linkStyle, color: hovered ? '#34D399' : '#64748b' }}
        >
            {label}
        </span>
    );
}

function genCaptcha() {
    const a = Math.floor(Math.random() * 9) + 1;
    const b = Math.floor(Math.random() * 9) + 1;
    return { a, b, answer: a + b };
}

export default function Footer() {
    const navigate = useNavigate();
    const year = new Date().getFullYear();

    // Modal contact
    const [showContact, setShowContact] = useState(false);
    const [form, setForm]               = useState({ name: '', email: '', message: '' });
    const [captcha, setCaptcha]         = useState(genCaptcha());
    const [captchaInput, setCaptchaInput] = useState('');
    const [sending, setSending]         = useState(false);
    const [msg, setMsg]                 = useState('');
    const [msgType, setMsgType]         = useState('success');

    useEffect(() => {
        if (showContact) {
            setCaptcha(genCaptcha());
            setCaptchaInput('');
            setForm({ name: '', email: '', message: '' });
            setMsg('');
        }
    }, [showContact]);

    const handleSubmit = async () => {
        if (!form.name || !form.email || !form.message) {
            setMsg('Please fill in all fields.'); setMsgType('error'); return;
        }
        if (parseInt(captchaInput) !== captcha.answer) {
            setMsg('Incorrect answer. Please try again.');
            setMsgType('error');
            setCaptcha(genCaptcha());
            setCaptchaInput('');
            return;
        }
        setSending(true);
        try {
            const res = await fetch('/api/contact.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form)
            });
            const data = await res.json();
            if (data.success) {
                setMsg('Message sent! We will get back to you soon.');
                setMsgType('success');
                setForm({ name: '', email: '', message: '' });
                setTimeout(() => setShowContact(false), 3000);
            } else {
                setMsg(data.error || 'An error occurred.');
                setMsgType('error');
            }
        } catch {
            setMsg('Unable to reach the server.');
            setMsgType('error');
        }
        setSending(false);
    };

    const socials = [
        {
            title: 'Twitter / X',
            href: 'https://twitter.com/online_ico',
            icon: <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.261 5.636 5.903-5.636zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
        },
        {
            title: 'Telegram',
            href: '#',
            icon: <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
        },
        {
            title: 'Discord',
            href: '#',
            icon: <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/></svg>
        },
    ];

    const inputStyle = {
        width: '100%', background: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px',
        padding: '10px 14px', color: '#fff', fontSize: '0.85rem',
        outline: 'none', boxSizing: 'border-box', fontFamily: 'Inter, sans-serif'
    };

    return (
        <>
            <footer style={{
                background: 'rgba(5,8,20,0.98)',
                borderTop: '1px solid rgba(255,255,255,0.06)',
                padding: '48px 24px 24px',
                marginTop: '60px',
            }}>
                <div style={{ maxWidth: '1100px', margin: '0 auto' }}>

                    {/* ROW 1 : Logo + Socials */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '24px', marginBottom: '40px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <img src={logo} alt="OnlineICO" style={{ width: '38px', height: '38px', objectFit: 'contain' }} />
                            <div>
                                <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '1rem', color: '#F1F5F9', letterSpacing: '1.5px' }}>ONLINEICO</div>
                                <div style={{ fontSize: '0.7rem', color: '#475569', marginTop: '2px' }}>The crypto launch platform</div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            {socials.map(({ title, href, icon }) => (
                                <a key={title} href={href} target="_blank" rel="noopener noreferrer" title={title}
                                    style={{ width: '36px', height: '36px', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.03)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b', textDecoration: 'none', transition: 'all 0.2s' }}
                                    onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(52,211,153,0.35)'; e.currentTarget.style.color = '#34D399'; e.currentTarget.style.background = 'rgba(52,211,153,0.07)'; }}
                                    onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = '#64748b'; e.currentTarget.style.background = 'rgba(255,255,255,0.03)'; }}>
                                    {icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* ROW 2 : 3 colonnes */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '32px', marginBottom: '40px' }}>

                        {/* Colonne 1 — Navigation */}
                        <div>
                            <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '16px' }}>◧ Navigation</div>
                            <FooterLink label="◧ Home"           onClick={() => navigate('/')} />
                            <FooterLink label="📋 Listings"      onClick={() => navigate('/listings')} />
                            <FooterLink label="⚡ Earn"          onClick={() => navigate('/earn')} />
                            <FooterLink label="🎨 Token Studio"  onClick={() => navigate('/token-studio')} />
                        </div>

                        {/* Colonne 2 — Services */}
                        <div>
                            <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '16px' }}>Services</div>
                            <FooterLink label="List Your Project"   onClick={() => navigate('/add-crypto-project-ico')} />
                            <FooterLink label="🎨 Token Studio"  onClick={() => navigate('/token-studio')} />
                            <FooterLink label="✉ Contact"        onClick={() => setShowContact(true)} />
                        </div>

                        {/* Colonne 3 — Legal */}
                        <div>
                            <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '16px' }}>TERMS</div>
                            <FooterLink label="Terms and Conditions" onClick={() => navigate('/terms')} />
                            <FooterLink label="Privacy Policy"       onClick={() => navigate('/privacy')} />
                            <FooterLink label="Cookie Policy"        onClick={() => navigate('/cookies')} />
                        </div>
                    </div>

                    {/* SÉPARATEUR */}
                    <div style={{ height: '1px', background: 'rgba(255,255,255,0.05)', marginBottom: '16px' }} />

                    {/* ROW 3 : Copyright */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                        <div style={{ color: '#334155', fontSize: '0.73rem', textDecoration: 'underline' }}>© {year} OnlineICO — All rights reserved</div>
                        <span 
                            style={{ color: '#334155', fontSize: '0.73rem', textDecoration: 'underline', textUnderlineOffset: '3px' }}
                            onMouseEnter={e => e.currentTarget.style.color = '#64748b'}
                            onMouseLeave={e => e.currentTarget.style.color = '#334155'}>
                            Crypto - Token & Quests - ICO - IDO
                        </span>
                    </div>
                </div>
            </footer>

            {/* ── MODAL CONTACT ── */}
            {showContact && (
                <div onClick={() => setShowContact(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(6px)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                    <div onClick={e => e.stopPropagation()} style={{ background: '#0B1120', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '24px', padding: '32px', width: '100%', maxWidth: '480px' }}>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '1.1rem', color: '#fff' }}>✉ Contact us</div>
                            <button onClick={() => setShowContact(false)} style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: '1.3rem', padding: 0, lineHeight: 1 }}>×</button>
                        </div>

                        {msg && (
                            <div style={{ marginBottom: '16px', padding: '10px 14px', borderRadius: '10px', fontSize: '0.82rem',
                                background: msgType === 'success' ? 'rgba(52,211,153,0.1)' : 'rgba(239,68,68,0.1)',
                                color: msgType === 'success' ? '#34D399' : '#f87171',
                                border: `1px solid ${msgType === 'success' ? 'rgba(52,211,153,0.3)' : 'rgba(239,68,68,0.3)'}` }}>
                                {msg}
                            </div>
                        )}

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                            <div>
                                <label style={{ fontSize: '0.78rem', color: '#94a3b8', marginBottom: '6px', display: 'block' }}>Name *</label>
                                <input style={inputStyle} placeholder="Your name" value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} />
                            </div>
                            <div>
                                <label style={{ fontSize: '0.78rem', color: '#94a3b8', marginBottom: '6px', display: 'block' }}>Email *</label>
                                <input style={inputStyle} type="email" placeholder="your@email.com" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
                            </div>
                            <div>
                                <label style={{ fontSize: '0.78rem', color: '#94a3b8', marginBottom: '6px', display: 'block' }}>Message *</label>
                                <textarea style={{ ...inputStyle, resize: 'vertical', minHeight: '110px' }} placeholder="Your message..." value={form.message} onChange={e => setForm(p => ({ ...p, message: e.target.value }))} />
                            </div>

                            {/* CAPTCHA */}
                            <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', padding: '14px' }}>
                                <label style={{ fontSize: '0.78rem', color: '#94a3b8', marginBottom: '8px', display: 'block' }}>
                                    🤖 Anti-bot — What is <span style={{ color: '#a78bfa', fontWeight: '700' }}>{captcha.a} + {captcha.b}</span> ?
                                </label>
                                <input style={{ ...inputStyle, width: '100px' }} type="number" placeholder="Answer" value={captchaInput} onChange={e => setCaptchaInput(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
                            </div>

                            <button onClick={handleSubmit} disabled={sending} style={{ padding: '12px', background: 'linear-gradient(135deg, #8B5CF6, #6D28D9)', border: 'none', borderRadius: '12px', color: '#fff', fontWeight: '700', fontSize: '0.9rem', cursor: 'pointer', opacity: sending ? 0.6 : 1, marginTop: '4px' }}>
                                {sending ? 'Sending...' : 'Send message →'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
